import { Box, IconButton, Tooltip } from "@mui/material";
import PropTypes from "prop-types";
import { DOCUMENT_TYPE_ICON_OPTIONS } from "./documentTypeIconOptions.js";

/**
 * A visual picker over the fixed DOCUMENT_TYPE_ICON_OPTIONS set - not a
 * free-text icon name.
 * Used both inline in DocumentTypesTable (persists immediately on selection)
 * and inside DocumentTypeFormModal (sets the form field, saved on submit).
 */
export default function DocumentTypeIconPicker({ value, onChange }) {
  return (
    <Box display="flex" flexWrap="wrap" gap={0.5}>
      {DOCUMENT_TYPE_ICON_OPTIONS.map(({ name, Icon }) => (
        <Tooltip key={name} title={name}>
          <IconButton
            aria-label={name}
            aria-pressed={value === name}
            onClick={() => onChange(name)}
            sx={{
              border: "1px solid",
              borderColor: value === name ? "primary.main" : "grey.300",
              backgroundColor: value === name ? "primary.light" : "transparent",
            }}
          >
            <Icon fontSize="small" />
          </IconButton>
        </Tooltip>
      ))}
    </Box>
  );
}

DocumentTypeIconPicker.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};
